// extracted by mini-css-extract-plugin
export default {"statistics__container":"Statistics_statistics__container__j9bri","statistics__head":"Statistics_statistics__head__ETb3S","statistics__list":"Statistics_statistics__list__29B7W"};